<app-client-info></app-client-info>
<app-case-info [Invoices]="Invoices"></app-case-info>

<app-table (parentFunc)="tablerowFunc($event)" [sizeOptions]="sizeOptions" [Title]="tableTitle" [Collection]="this.Collection" [displayedColumns]="displayedColumns"></app-table>
